import template from './form.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import salariosI18N from 'i18n/salarios/es.json';
import commonI18N from 'i18n/common/es.json';
import config from 'config.json';
import { download } from '../../../core/util';
import { formatErrorMessage } from 'core/util';

export let SalarioFormComponent = {
  templateUrl: template,
  selector: 'salarioForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(salariosI18N).concat(Object.keys(commonI18N));


FormController.$inject = ['$state', '$ngRedux', 'ngNotify', '$stateParams', '$timeout', '$scope', 'BasicFactory', 'Filter', '$resource', 'HeadersUtil'];

function FormController($state, $ngRedux, ngNotify, $stateParams, $timeout, $scope, BasicFactory, Filter, $resource, HeadersUtil) {
  Object.assign(this, {
    $state,
    $ngRedux,
    ngNotify,
    $stateParams,
    $timeout
  });

  this.cancel = cancel.bind(this);
  //this.doSubmit = doSubmit.bind(this);

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.loadEmpleados = loadEmpleados.bind(this);
  this.renderEmpleado = renderEmpleado.bind(this);

  this.loadPeriodoNominas = loadPeriodoNominas.bind(this);
  this.renderPeriodoNomina = renderPeriodoNomina.bind(this);
  this.changePeriodo = changePeriodo.bind(this);

  this.clearDetalles = clearDetalles.bind(this);
  this.toggleDetalles = toggleDetalles.bind(this);

  this.generar = generar.bind(this);
  this.procesar = procesar.bind(this);
  this.descargarCSV = descargarCSV.bind(this);


  this.localModel = {};

  let unsubscribe;

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  const valoresFilter = Filter.path('tipo.codigo').eq('estado_salario');


  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver resumen salarios'] : this.translations['Resumen salario'];
      this.formEdit('salarios', $stateParams.uid);
    } else {
      this.title = this.translations['Resumen salario'];
      this.form();
    }
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));

  };

  this.init = false;

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;

    this.model = state.form.model;

    if (state.form.created) {
      ngNotify.set(this.translations['Liquidacion procesada'], 'success');
      //$state.go('home.salarios.list');
      this.model = state.form.created;
      this.localModel.mostrarDetalles = true;
    }

    if (!this.model.id && state.valores.data && state.valores.data.length > 0) {
      this.estadosCabecera = state.valores.data.filter(v => v.tipo.codigo === 'estado_salario');
      this.model.estado = this.estadosCabecera.filter(v => v.value === 'No procesado')[0];
    } else if (this.model.id && !this.init) {
      this.init = true;
      this.changePeriodo();
      this.localModel.fechaGeneracion = moment(this.model.fechaGeneracion).format('DD/MM/YYYY');
      this.localModel.mostrarDetalles = true;
    }

    return {
      form: state.form
    };
  }

  function toggleDetalles() {
    console.log(this.localModel);
  }

  /**
   * Función que se encarga de mostrar mensajes de error en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.salarios.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }
  }


  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go('home.salarios.list');
  }

  function procesar() {
    let self = this;
    let payload = { procesado: true };
    $ngRedux.dispatch(rest.actions.procesarSalario({ id: this.model.id }, {
      body: JSON.stringify(payload)
    }, (err, data) => {
      if (!err && data.code == 200) {
        ngNotify.set(self.translations['Resumen de salario marcado como procesado'], 'success');
        $state.go('home.salarios.list');
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }
    }));
  }

  function generar() {
    if (!this.model.empleado) {
      this.ngNotify.set(this.translations['Seleccionar empleado'], 'warn');
      return;
    }
    if (!this.model.periodoNomina) {
      this.ngNotify.set(this.translations['Seleccionar periodo'], 'warn');
      return;
    }

    if ($scope.salarioForm.$invalid) {
      this.submitted = true;
      return;
    }
    let data = Object.assign({}, this.model);
    data.empleado = null;
    data.empleadoId = this.model.empleado.id;
    this.save('salarios', data);
  }

  function loadEmpleados(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('numeroDocumento').like(query))
        .or(Filter.path('tipoDocumento.value').like(query))
        .or(Filter.path('sexo.value').like(query))
        .or(Filter.path('estadoCivil.value').like(query))
        .or(Filter.path('telefono').like(query)));
    }
    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function renderEmpleado(empleado) {
    return `${empleado.nombre} ${empleado.apellido}`;
  }

  function loadPeriodoNominas(query) {
    let filter = Filter.path('activo').eq(true).and(Filter.path('estado.value').eq('Cerrado'));

    // if (this.model.fecha) {
    //   filter = filter.and(Filter.path('desde').lte(this.model.fecha).and(Filter.path('hasta').gte(this.model.fecha)));
    // }

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('periodos-nominas');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function renderPeriodoNomina(periodoNomina) {
    return `${periodoNomina.nombre}`;
  }

  function changePeriodo() {
    this.localModel.periodo = moment(this.model.periodoNomina.desde).format('DD/MM/YYYY') + ' - ' + moment(this.model.periodoNomina.hasta).format('DD/MM/YYYY');
  }

  function clearDetalles() {
    this.model.detalles = null;
  }

  function descargarCSV() {
    download('salarios', this.model.id, 'csv', config, $resource, HeadersUtil);
  }
}


// WEBPACK FOOTER //
// ./src/components/salarios/form/form.component.js